<template>
  <div style="background-color: #F2F2F2;">

    <div class="GlobalHeader">
      <my-GlobalHeader @search-click="searchClick" />
    </div>

    <div clxxass="Header">
      <my-Header :class="{fixed:isFixed,active:isActive}" :nav-list="navList" :subList="subList" />
    </div>
    <div class="Homebanner">
      <my-HomeBanner :bannerList="this.bannerList" />
    </div>

    <div class="Tans">
      <my-Tans :NoticeList="noticeList" />
    </div>

    <div class="home box" style="background-color: #F2F2F2">

        <div class="Washingto">
          <my-Washingto :newList="newList" />
        </div>
        <div class="home__body">
          <div class="home-left">
                <my-Notaic :getNewList="getNewList1"></my-Notaic>
                <my-Notaic :getNewList="getNewList2"></my-Notaic>
                <my-Notaic class="come-min" :getNewList="getNewList3"></my-Notaic>
                <my-Notaic  class="come-min" :getNewList="getNewList4"></my-Notaic>
          </div>
          <div class="home-right">
            <div class="home-right-Video">
              <my-Video :getVList="getVList"/>
            </div>
          </div>

        </div>
        <div class="Topic">
          <my-Topic :getZlList="getZlList"></my-Topic>
        </div>
      <div class="come_body home__body">
        <div class="home-left" style="width: 66%">
          <my-Notaics :getNewList="getNewList5"></my-Notaics>
          <my-Notaics :getNewList="getsssList"></my-Notaics>
        </div>
        <div class="home-right" style="width: 33%">
<!--          <my-Qiecut :getCyList="getCyList"></my-Qiecut>-->
          <my-Notaics :getNewList="getCyList"></my-Notaics>
        </div>
      </div>

    </div>
    <div class="Carousel home box  ">
      <my-Carousel :getList="getHrdw"/>
    </div>
    <div class="end home box">
      <my-End/>
    </div>
    <div class="end1">
      <my-EndText/>
    </div>

  </div>


</template>

<script>
import axios from 'axios'
import GlobalHeader from '@/components/GlobalHeader'
import Homebanner from '@/components/Homebanner'
import Washingto from '@/components/Washingto'
import HomeNav from '@/components/HomeNav'
import End from '@/components/End'
import EndText from '@/components/End-text'
import Header from '@/components/Header'
import Notaic from '@/components/Notaic'
import Notaics from '@/components/Notaics'
import Carousel from '@/components/Carousel'
import Video from '@/components/Video'
import Topic from '@/components/Topic'
import Qiecut from '@/components/Qiecut'
import Tans from '@/components/HomeTabs-right'

import {orgId, requestUrl} from '../common/cons'

export default {
  name: "Home",
  components:{
    'my-GlobalHeader': GlobalHeader,
    'my-HomeBanner': Homebanner,
    'my-Washingto': Washingto,
    'my-HomeNav': HomeNav,
    'my-End': End,
    'my-EndText': EndText,
    'my-Header': Header,
    'my-Notaic': Notaic,
    'my-Notaics': Notaics,
    'my-Carousel': Carousel,
    'my-Topic': Topic,
    'my-Qiecut': Qiecut,
    'my-Video':Video,
    'my-Tans':Tans
  },
  data(){
    return{
      isFixed:false,
      isActive:true,
      navList:[],
      subList:[],
      bannerList:[],
      newList:[],
      getNewList1:{},
      getNewList2:{},
      getNewList3:{},
      getNewList4:{},
      getNewList5:{},
      getCyList:{},
      getZlList:[],
      getVList:[],
      getsssList:{},
      getHrdw:[],
      noticeList:[]
    }
  },
  watch:{
  },
  async created () {
    await this.init()
  },
  methods:{
    async init () {
      this.queryNavList()
      this.queryBannerList()
      this.queryNewList()
      this.queryGetNewList1()
      this.queryGetNewList2()
      this.queryGetNewList3()
      this.queryGetNewList4()
      this.queryGetNewList5()
      this.queryCyList()
      this.queryZlList()
      this.queryVideoList()
      this.querysssList()
      this.queryHrdw()
      this.getNoticeList()
    },
    async getNoticeList () {
      const { data } = await axios.get(`${requestUrl}/notice/${orgId}`)
      this.noticeList = data
    },
    async queryNavList(){
      const result = await axios.get(`${requestUrl}/nav/${orgId}`)
      this.navList = result.data
      const idList = []
      this.navList.forEach((item, index) => {
        idList.push(item.colmun_id)
      })
      const subList = await axios.get(`${requestUrl}/dnjt/nav/column?idList=${idList}`)
      this.navList.splice(3, 0, { id: 100, title: '党建引领', column_id: '451', isLink: true}, { id: 101, title: '企业文化', column_id: '394', isLink: true}, { id: 102, title: '网上办公', column_id: 'target'})
      subList.data.forEach((item, index) => {
        this.subList.push(item)
      })
      this.subList.splice(3, 0, [], [], [])
    },
    async  queryBannerList(){
      const result = await axios.get(`${requestUrl}/banner/getBannerList?bannerTitle=banner&orgId=${orgId}`)
      result.data.forEach((item, index) => {
        if (item.img === '' || item.img === null) {
          result.data.splice(index, 1)
        }
      })
      this.bannerList = result.data
    },
    async queryNewList(){
      let s='hr-new'
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=${s}&orgId=${orgId}&text=1`)
      this.newList=newData.data
    },
    async queryVideoList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=video&orgId=${orgId}`)
      this.getVList=newData.data
    },
    async queryGetNewList1(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-1&orgId=${orgId}`)
      this.$set(this.getNewList1,"id",0)
      this.$set(this.getNewList1,"data",newData.data)
    },
    async queryGetNewList2(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-2&orgId=${orgId}`)
      this.$set(this.getNewList2,"id",1)
      this.$set(this.getNewList2,"data",newData.data)
    },
    async queryGetNewList3(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-3&orgId=${orgId}`)
      this.$set(this.getNewList3,"id",2)
      this.$set(this.getNewList3,"data",newData.data)
    },
    async queryGetNewList4(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-4&orgId=${orgId}`)
      // 单独处理 加入二维码
      // newData.data.push({
      //   id: 0,
      //   name: '举报平台',
      //   icon: 'https://www.cmjt.com.cn/assets/2022/11/01/7768b296825d420e8bef00aee6e433d9.jpg'
      // })
      this.$set(this.getNewList4,"id",3)
      this.$set(this.getNewList4,"data",newData.data)
    },
    async queryGetNewList5(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-5&orgId=${orgId}`)
      this.$set(this.getNewList5,"id",4)
      this.$set(this.getNewList5,"data",newData.data)
    },
    async querysssList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-6&orgId=${orgId}`)
      this.getsssList = newData.data
      this.$set(this.getsssList,"id",5)
      this.$set(this.getsssList,"data",newData.data.slice(0,3))
    },
    async queryCyList(){
      const newData = await axios.get(`${requestUrl}/news/getNewsList?blockCode=new-7&orgId=${orgId}`)
      this.$set(this.getCyList, "id", 6)
      this.$set(this.getCyList, "data", newData.data)
    },
    async queryZlList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=hrjt-zl&orgId=${orgId}`)
      this.getZlList=newData.data
    },
    async queryHrdw(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=hr-dw&orgId=${orgId}`)
      this.getHrdw=newData.data
    },

    handleScroll(e){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop>20){
        this.isFixed=true;
        this.isActive=false
      }else {
        this.isFixed=false
        this.isActive=true
      }
    },
    searchClick (keywords) {
      this.$router.push({
        path: '/news/443',
        query: {
          keywords: keywords
        }
      })
    }
  },

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}

.box{
  width: 1100px;
}
.GlobalHeader{
  display: flex;
  justify-content: center;
  align-items: center;
}
.fixed{
  position: fixed;
  top: 0;
  z-index: 999;
}
.active{
  position: fixed;
  top: 80px;
  z-index: 999;
}
.home-right{
  width: 25%;
  height: 400px;
  margin-left: 10px;
}
.home-left{
  width: 75%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
}
.come-min{
  margin: 10px 0;
}
.home-right-Video{
  width: 100%;

  /*border: 1px solid #d0d0d0;*/
  /*box-shadow: 1px 1px 4px #ccc;*/
  position: relative;
  box-sizing: border-box;
}
.Washingto{
  margin-top:20px;
}
.HomeTabs{
  padding: 0;
  display: flex;
  flex-direction: column;
  /*height: 100%;*/
  justify-content: space-between;
}
.tabs{

  /*margin-top: 25px;*/
}
.home{
 /*margin-left: 100px;*/
 /* margin-right: 100px;*/
  width: 1200px;
  margin: 0 auto;
}

.home__body{
  width: 100%;
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
}
.come_body{
  height: 355px;
}

.Carousel .text{
  background-color: #409EFF;
  color: #fff;
  margin: 10px 10px 0 0;
  padding: 10px;
  display: inline-block;
  float: left;
  width: 20px;
  height: 150px;
  text-align: center;
}
.Tans{

 align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue